import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGet() {
  const mainDeliverables = [{
    title: '📘 El Manual Original Cero Panza 14',
    desc: 'La hoja de ruta completa del protocolo de 14 días. Qué comer, cuándo comer, cómo activar tu metabolismo sin destruir tu vida social.'
  }, {
    title: '📋 Lista de Compras Alpha',
    desc: 'Qué comprar en el súper de tu barrio. Sin productos raros. Sin gastar más de lo que gastás hoy.'
  }, {
    title: '⏱️ Plan Día a Día',
    desc: 'Exactamente qué hacer desde que te levantás hasta que te acostás. Sin decisiones. Sin adivinar. Solo seguir el mapa.'
  }];
  const bonuses = [{
    title: '🔥 BONO #1 — Guía de Supervivencia en el BBQ',
    value: '$27',
    desc: 'Cómo ir al asado, comer carne, tomar algo y no arruinar todo lo que avanzaste. Porque la vida real incluye domingos con amigos.'
  }, {
    title: '⚡ BONO #2 — Rutina Alpha 5',
    value: '$35',
    desc: '5 minutos. 5 ejercicios. Sin gimnasio. La activación metabólica que potencia el protocolo sin destruirte las rodillas.'
  }, {
    title: '🗓️ BONO #3 — Planificador 14 Días',
    value: '$27',
    desc: 'El calendario exacto para no tener que pensar. Semana 1: The Flush. Semana 2: The Burn.'
  }];
  return <section className="bg-dark-surface text-white py-20 px-4 md:px-8" data-id="element-148">
      <div className="max-w-5xl mx-auto" data-id="element-149">
        <h2 className="font-oswald text-3xl md:text-5xl font-bold mb-4 text-center uppercase" data-id="element-150">
          Cuando descargás{' '}
          <span className="text-brand-orange" data-id="element-151">Cero Panza 14</span> hoy, recibís:
        </h2>

        {/* Main deliverables */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-152">
          {mainDeliverables.map((item, index) => <div key={index} className="bg-dark-bg p-6 rounded-lg border border-gray-800" data-id="element-153">
              <h3 className="font-oswald text-xl font-bold mb-3 uppercase text-white" data-id="element-154">
                {item.title}
              </h3>
              <p className="font-inter text-gray-400 text-sm leading-relaxed" data-id="element-155">
                {item.desc}
              </p>
            </div>)}
        </div>

        {/* Bonuses */}
        <div className="bg-dark-bg rounded-xl p-8 border-2 border-brand-orange/30" data-id="element-156">
          <h3 className="font-oswald text-2xl md:text-3xl font-bold mb-8 text-center uppercase text-brand-orange" data-id="element-157">
            + Bonos Exclusivos (Valor $89)
          </h3>
          <div className="space-y-6" data-id="element-158">
            {bonuses.map((bonus, index) => <div key={index} className="flex flex-col md:flex-row md:items-start justify-between border-b border-gray-800 pb-6 last:border-0 last:pb-0" data-id="element-159">
                <div className="flex-1" data-id="element-160">
                  <h4 className="font-oswald text-lg font-bold mb-2 uppercase text-white" data-id="element-161">
                    {bonus.title}
                  </h4>
                  <p className="font-inter text-gray-400 text-sm" data-id="element-162">
                    {bonus.desc}
                  </p>
                </div>
                <span className="font-oswald text-gray-500 line-through mt-2 md:mt-0 md:ml-4 text-lg" data-id="element-163">
                  Valor {bonus.value}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}